import {
  BarcodeOutlined,
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  EditOutlined,
  FilePdfOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import Page from "_components/Page";
import { CurrencyFormatter } from "_helpers/formatters";
import {
  addressService,
  materialDetailService,
  stockReceiptService,
  taxTypeService,
} from "_services";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  PageHeader,
  Popconfirm,
  Row,
  Select,
  Spin,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Typography,
  Statistic,
} from "antd";

import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Stepper from "./Stepper";
import TabMenu from "./TabMenu";
import { StockReceiptOrderStage } from "_helpers";
import AddMaterialDrawer from "./Drawer";
import { render } from "react-dom/cjs/react-dom.production.min";

const { Title } = Typography;

function TiepSummary({ history, match }) {
  const location = useLocation();

  const response = location.state;

  const { id } = match.params;
  const { path } = match;

  const [form] = Form.useForm();
  const [newLineForm] = Form.useForm();
  const [addEditStockItemForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingUpdateStocks, setLoadingUpdateStocks] = useState(false);
  const [loadingDownloadExcel, setLoadingDownloadExcel] = useState(false);
  const [loadingDownloadCsv, setLoadingDownloadCsv] = useState(false);
  const [loadingDetailsUpdate, setLoadingDetailsUpdate] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingLineItems, setLoadingLineItems] = useState(false);
  const [loadingStatusUpdate, setLoadingStatusUpdate] = useState(false);
  const [loadingNewLine, setLoadingNewLine] = useState(false);
  const [loadingAddEditStockItem, setLoadingAddEditStockItem] = useState(false);
  const [loadingLineDelete, setLoadingLineDelete] = useState(false);
  const [order, setOrder] = useState({});
  //const [orderLines, setOrderLines] = useState(null);
  const [stores, setStores] = useState([]);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [customerAddresses, setcustomerAddresses] = useState([]);
  const [stockItems, setStockItems] = useState([]);
  const [materialTypes, setMaterialTypes] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const [selectedGrnLineKeys, setSelectedGrnLineKeys] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState(null);
  const [lineItemMap, setLineItemMap] = useState(new Map());
  const [customer, setCustomer] = useState(null);
  const [newLineDrawerVisible, setNewLineDrawerVisible] = useState(false);
  const [addEditStockItemDrawerVisible, setAddEditStockItemDrawerVisible] =
    useState(false);
  const [addEditMode, setAddEditMode] = useState("Add");
  const [isNewStockItems, setIsNewStockItems] = useState(false);
  const [activeLineId, setActiveLineId] = useState(null);
  const [error, setError] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [receiptStage, setReceiptStage] = useState("OPEN");
  const [selectedLine, setSelectedLine] = useState(null);
  const [taxTypes, setTaxTypes] = useState([]);
  const { Option } = Select;
  const { Text } = Typography;

  useEffect(() => {
    getStockReceipt();
    getTaxTypes();
  }, [receiptStage]);

  const getTaxTypes = () => {
    taxTypeService
      .getAll()
      .then((data) => setTaxTypes(data.content))
      .catch((error) => message.error(error));
  };

  const getStockReceipt = () => {
    setLoading(true);
    stockReceiptService
      .getByOrderId(id)
      .then((data) => {
        setOrder(data.content);
        setReceiptStage(data.content?.orderStage ?? "OPEN");
        onFill(data.content);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getStoreAddresses = (companyId) => {
    addressService.getAllByCompany(companyId).then((x) => {
      setStoreAddresses(x.content);
    });
  };

  const getcustomerAddresses = (companyId) => {
    addressService.getAllByCompany(companyId).then((x) => {
      setcustomerAddresses(x.content);
    });
  };

  const handlePrintPdf = () => {
    setLoadingPdf(true);
    stockReceiptService.printPdf(id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Stock-in-${order.receiptNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoadingPdf(false);
    });
  };

  const handleDownloadExcelStockDetails = () => {
    setLoadingDownloadExcel(true);
    stockReceiptService
      .downloadExcelStockDetails(id)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Barcodes_${order.receiptNumber}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoadingDownloadExcel(false);
      })
      .catch((error) => {
        setLoadingDownloadExcel(false);
        message.error(error);
      });
  };

  const handleDownloadCsvStockDetails = () => {
    setLoadingDownloadCsv(true);
    stockReceiptService
      .downloadCsvStockDetails(id)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Update_Stock_Details_${order.receiptNumber}.csv`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoadingDownloadCsv(false);
      })
      .catch((error) => {
        setLoadingDownloadCsv(false);
        message.error(error);
      });
  };

  const handleFormSumbit = () => {
    newLineForm
      .validateFields()
      .then((values) => {
        setLoadingNewLine(true);

        if (!values.id) {
          values.measurementType = {
            id: measurementTypes.find((item) => item.name === "Kg").id,
          };
          values.stockClass = {
            id: materialTypes.find((item) => item.id === values.stockType.id)
              .stockClass.id,
          };
          values.packingType = {
            id: materialTypes.find((item) => item.id === values.stockType.id)
              .packingType.id,
          };
          let payload = {
            id: id,
            receiptNumber: order.receiptNumber,
            actionType: "ADD_NEW_LINE",
            stockReceiptLines: [values],
          };

          stockReceiptService
            .update(id, payload)
            .then(() => {
              message.success("Successfully updated!");
              setLoadingNewLine(false);
              newLineForm.resetFields();
              onCloseNewLineDrawer();
              window.location.reload();
            })
            .catch((error) => {
              setLoadingNewLine(false);
              setError(error);
              newLineForm.resetFields();
              onCloseNewLineDrawer();
            });
        } else {
          stockReceiptService
            .updateLine(id, activeTabKey, values)
            .then(() => {
              message.success("Successfully updated!");
              setLoadingNewLine(false);
              newLineForm.resetFields();
              onCloseNewLineDrawer();
              window.location.reload();
              //history.push(`${path}`.replace(":id", id));
            })
            .catch((error) => {
              setLoadingNewLine(false);
              setError(error);
              newLineForm.resetFields();
              onCloseNewLineDrawer();
            });
        }
      })
      .catch((errorInfo) => {});
  };

  const handleUpdateDetails = () => {
    form
      .validateFields()
      .then((values) => {
        setLoadingDetailsUpdate(true);
        const payLoad = {
          id: id,
          receiptNumber: order.receiptNumber,
          receivedDate: moment(values.receivedDate).format("YYYY-MM-DD"),
          supplier: values.supplier,
          packingStatus: values.packingStatus,
        };
        stockReceiptService
          .update(id, payLoad)
          .then(() => {
            message.success("Successfully updated!");
            setLoadingDetailsUpdate(false);
            history.push(`${path}`.replace(":id", id));
          })
          .catch((error) => {
            setLoadingDetailsUpdate(false);
            setError(error);
          });
      })
      .catch((error) => {
        setError(error);
      });
  };

  const handleAddEditStockItem = () => {
    addEditStockItemForm
      .validateFields()
      .then((values) => {
        setLoadingAddEditStockItem(true);

        if (isNewStockItems) {
          let payload = {
            receiptLine: { id: activeLineId },
            numberOfBox: values.numberOfBox,
            packingStatus: values.packingStatus,
          };

          materialDetailService
            .create(payload)
            .then(() => {
              message.success("Successfully created!");
              setLoadingAddEditStockItem(false);
              addEditStockItemForm.resetFields();
              onCloseAddEditStockItemDrawer();
              window.location.reload();
            })
            .catch((error) => {
              setLoadingAddEditStockItem(false);
              setError(error);
              addEditStockItemForm.resetFields();
              onCloseAddEditStockItemDrawer();
            });
        } else {
          materialDetailService
            .update(values.id, values)
            .then(() => {
              message.success("Successfully updated!");
              setLoadingAddEditStockItem(false);
              addEditStockItemForm.resetFields();
              onCloseAddEditStockItemDrawer();
              window.location.reload();
            })
            .catch((error) => {
              setLoadingAddEditStockItem(false);
              setError(error);
              addEditStockItemForm.resetFields();
              onCloseAddEditStockItemDrawer();
            });
        }
      })
      .catch((errorInfo) => {});
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
    form.setFieldValue(
      "receiptType",
      data?.receiptType === "TIEP" ? "DIRECT" : "INDIRECT"
    );
  };

  const onComplete = (status) => {
    setLoadingStatusUpdate(true);
    setLoading(true);

    const statusUpdatePayload = {
      receiptStatus: status,
    };
    stockReceiptService
      .updateStatus(id, statusUpdatePayload)
      .then(() => {
        if (status == "COMPLETE") {
          message.success("Successfully completed!");
        }

        setLoadingStatusUpdate(false);
        setLoading(true);
        order.orderStage = status;
        setReceiptStage(status);
        history.push(match.path?.replace(":id", id));
      })
      .catch((error) => {
        setLoadingStatusUpdate(false);
        setError(error);
        setLoading(true);
      });
  };

  const onCancel = () => {
    history.push("/stock-receipts");
  };

  const handleStockReceipt = () => {
    history.push(`/stock-receipts/${id}`);
  };

  const handleLineEditButtonClick = (lineId) => {
    const receiptLine = order.receiptLines.find((line) => line.id === lineId);

    setSelectedLine(receiptLine);
    // newLineForm.setFieldsValue(receiptLine);
    // setAddEditMode("Edit");
    setNewLineDrawerVisible(true);
  };

  const handleDrawerOnLineEditSubmit = (values) => {
    setLoading(true);
    setNewLineDrawerVisible(false);

    const payload = {
      id: values.id,
      itemNumber: values.itemNumber,
      vat: values.vat,
      stockType: { id: values.stockType.id },
      packingType: { id: values.packingType.id },
      netWeight: values.netWeight,
      grossWeight: values.grossWeight,

      tiepPackageQuantity: values.receivedQuantity,
      tiepQuantityPerPackage: values.quantityPerItem,

      itemTaxesGuarantedAmount: null,
      stockReceiptLineTaxes: Object.values(
        values.stockReceiptLineTaxes || {}
      ).map((item) => ({
        id: item.id,
        taxAmount: item.taxAmount,
        //stockReceiptLine: { id: values.id },
        taxType: { id: item.taxType.id },
      })),
    };

    stockReceiptService
      .updateReceiptLine(id, payload.id, payload)
      .then((data) => {
        setSelectedLine(null);
        setLoading(false);
        getStockReceipt(data.content);
      })
      .catch((error) => {
        setError(error);
        message.error(error);
        setLoading(false);
      });
  };

  const handleLineDelete = (lineId) => {
    setLoadingLineDelete(true);
    stockReceiptService
      .deleteLine(id, lineId)
      .then((x) => {
        setLoadingLineDelete(false);
        message.success("Successfully line deleted!");
        window.location.reload();
      })
      .catch((error) => {
        setLoadingLineDelete(false);
        setError(error);
      });
  };

  const handleStockItemEdit = (stockItemId) => {
    const stock = lineItemMap
      .get(activeTabKey)
      .find((item) => item.id === stockItemId);

    addEditStockItemForm.setFieldsValue(stock);

    setIsNewStockItems(false);
    setAddEditMode("Edit");
    setAddEditStockItemDrawerVisible(true);
  };

  const handleStockItemDelete = (stockItemId) => {
    materialDetailService
      .delete(stockItemId)
      .then((x) => {
        message.success("Successfully deleted!");
        window.location.reload();
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const handleStockItemFormSumbit = () => {
    const payload = {
      stockItems: stockItems
        .filter((item) => item.quantity || item.netWeight || item.grossWeight)
        .map((item) => ({
          id: item.id,
          quantity: item.quantity,
          netWeight: item.netWeight,
          grossWeight: item.grossWeight,
        })),
    };
    setLoadingUpdateStocks(true);
    //console.log("PL: ", payload);
    materialDetailService
      .bulkUpdate(payload)
      .then((data) => {
        message.success("Successfully updated the stock item details.");
        setLoadingUpdateStocks(false);
      })
      .catch((error) => {
        setLoadingUpdateStocks(false);
        message.error(error);
      });
  };

  const showNewLineDrawer = () => {
    setAddEditMode("Add");
    setNewLineDrawerVisible(true);
  };

  const onCloseNewLineDrawer = () => {
    //if (!loadingNewLine) {
    newLineForm.resetFields();
    setNewLineDrawerVisible(false);
    //}
  };

  const showAddNewStockItemDrawer = (receiptLineId) => {
    const receiptLine = order.stockReceiptLines.find(
      (line) => line.id === receiptLineId
    );
    addEditStockItemForm.setFieldsValue(receiptLine);
    setActiveLineId(receiptLineId);
    setIsNewStockItems(true);
    setAddEditMode("Add");
    setAddEditStockItemDrawerVisible(true);
  };

  const onCloseAddEditStockItemDrawer = () => {
    if (!loadingAddEditStockItem) {
      addEditStockItemForm.resetFields();
      setAddEditStockItemDrawerVisible(false);
    }
  };

  const getActionButtons = () => {
    let buttons = [];
    // buttons.push(
    //   <Tooltip key="tp-pdf" placeholder="topLeft" title="PDF">
    //     <Button
    //       key="pdf"
    //       icon={<FilePdfOutlined />}
    //       onClick={handlePrintPdf}
    //       loading={loadingPdf}
    //     ></Button>
    //   </Tooltip>
    // );
    // buttons.push(
    //   <Tooltip
    //     key="tp-download-details"
    //     placeholder="topLeft"
    //     title="Download Stock Details"
    //   >
    //     <Button
    //       key="btn-download-details"
    //       icon={<DownloadOutlined />}
    //       onClick={handleDownloadCsvStockDetails}
    //       loading={loadingDownloadCsv}
    //     ></Button>
    //   </Tooltip>
    // );
    // buttons.push(
    //   <Tooltip
    //     key="tp-upload-details"
    //     placeholder="topLeft"
    //     title="Upload Stock Details"
    //   >
    //     <Button
    //       key="btn-upload-details"
    //       icon={<UploadOutlined />}
    //       href={`/material-details/update-via-upload/${id}`}
    //       target="_blank"
    //     ></Button>
    //   </Tooltip>
    // );
    // buttons.push(
    //   <Tooltip
    //     key="tp-download-full-details"
    //     placeholder="topLeft"
    //     title="Download Barcode Details"
    //   >
    //     <Button
    //       key="barcode"
    //       icon={<BarcodeOutlined />}
    //       onClick={handleDownloadExcelStockDetails}
    //       loading={loadingDownloadExcel}
    //     ></Button>
    //   </Tooltip>
    // );
    // buttons.push(
    //   <Tooltip key="tp-update" placeholder="topLeft" title="Update Details">
    //     <Button
    //       key="update"
    //       icon={<CheckOutlined />}
    //       onClick={handleUpdateDetails}
    //       loading={loadingDetailsUpdate}
    //     ></Button>
    //   </Tooltip>
    // );

    if (order.orderStage !== "COMPLETE") {
      const Status =
        order.orderStage == "OPEN"
          ? "UPDATE"
          : order.orderStage == "UPDATE"
          ? "COMPLETE"
          : "";

      buttons.push(
        <Popconfirm
          title={`Are you sure to ${Status} it?`}
          onConfirm={() => onComplete(Status)}
          key="con-complete"
          placement="bottomRight"
          //disabled={addedStocks.length === 0}
        >
          <Button
            key="btn-complete"
            htmlType="button"
            loading={loadingStatusUpdate}
          >
            {Status}
          </Button>
        </Popconfirm>
      );
    }
    buttons.push(
      <Button key="btn-cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "HS Code",
      key: "stockTypeCode",
      width: "5%",
      dataIndex: "stockTypeCode",
    });
    columns.push({
      title: "Material Code",
      dataIndex: "secondaryCode",
      key: "secondaryCode",
      width: "8%",
      align: "center",
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={text}>
            {text.substring(0, 8)}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: (
        <Tooltip title="Asycuda Item Number">
          <span>Item No.</span>
        </Tooltip>
      ),
      width: "5%",
      dataIndex: "itemNumber",
      key: "itemNumber",
      align: "center",
    });

    columns.push({
      title: "Description",
      key: "stockTypeName",
      dataIndex: "stockTypeName",
      width: "15%",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => <Tooltip title={text}>{text}</Tooltip>,
    });

    columns.push({
      title: "Package Type",
      dataIndex: ["receivedPackingTypeName"],
      key: "receivedPackingTypeName",
      align: "right",
    });

    columns.push({
      title: "No of Packages",
      dataIndex: "tiepPackageQuantity",
      key: "tiepPackageQuantity",
      align: "right",
    });

    columns.push({
      title: "QOP",
      width: "5%",
      dataIndex: ["tiepQuantityPerPackage"],
      key: "tiepQuantityPerPackage",
      align: "center",
    });

    columns.push({
      title: "UOM",
      width: "5%",
      dataIndex: ["receivedUomName"],
      key: "receivedUomName",
      align: "center",
    });

    columns.push({
      title: "Total Quantity",
      width: "5%",
      dataIndex: ["netWeight"],
      key: "netWeight",
      align: "center",
    });

    columns.push({
      title: "VAT",
      dataIndex: "totalVatAmount",
      key: "totalVatAmount",
      align: "right",
      render: (text, record) => <span>{CurrencyFormatter(text)}</span>,
    });

    columns.push({
      title: "Liability",
      dataIndex: "totalLiabilityAmount",
      key: "totalLiabilityAmount",
      align: "right",
      width: "6%",
      render: (text, record) => CurrencyFormatter(text ?? 0),
    });

    taxTypes.forEach((taxType) => {
      columns.push({
        title: taxType.name,
        dataIndex: "stockReceiptLineTaxes",
        align: "right",
        key: taxType.code,
        render: (text, record) => {
          const taxEntry = record.stockReceiptLineTaxes?.find(
            (tax) => tax?.taxType?.code === taxType.code
          );
          return <b>{CurrencyFormatter(taxEntry?.taxAmount ?? 0)}</b>;
        },
      });
    });

    if (["UPDATE"].includes(order?.orderStage)) {
      columns.push({
        title: "",
        key: "action",
        width: "6%",
        render: (text, record) => {
          return (
            <span>
              {["UPDATE"].includes(record.lineStatus) && (
                <Button
                  icon={<EditOutlined />}
                  title="Edit"
                  type="link"
                  style={{ marginRight: 10 }}
                  onClick={() => handleLineEditButtonClick(record.id)}
                ></Button>
              )}
              {["UPDATE"].includes(record.lineStatus) && (
                <Popconfirm
                  title="Are you sure to delete this line?"
                  onConfirm={() => handleLineDelete(record.id)}
                >
                  <CloseOutlined
                    loading={loadingLineDelete && record.key === activeTabKey}
                  />
                </Popconfirm>
              )}
            </span>
          );
        },
      });
    }

    return columns;
  };

  const getStockItemColumns = () => {
    let columns = [];
    columns.push({
      title: "HS Code",
      dataIndex: "stockType",
      key: "stockType",
      width: "10%",
      render: (text, record) => {
        return record.stockType && record.stockType.code;
      },
    });
    columns.push({
      title: "Material Code",
      dataIndex: "stockType.secondaryCode",
      width: "10%",
      key: "stockTypeSecondaryCode",
      render: (text, record) => {
        return (
          <Tooltip
            placeholder="topLeft"
            title={record?.stockType?.secondaryCode?.toString()}
          >
            {record?.stockType?.secondaryCode?.toString().substring(0, 8)}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      width: "25%",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockType.name}>
            {record.stockType.name}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Recv Date",
      dataIndex: "receivedDate",
      key: "receivedDate",
      width: "10%",
    });
    // columns.push({
    //   title: "Bin",
    //   key: "stockBin",
    //   width: "10%",
    //   render: (text, record) => {
    //     return record.stockBin && record.stockBin.code;
    //   },
    // });

    columns.push({
      title: "Issue Number",
      key: "issueNumber",
      width: "10%",
      render: (text, record) => {
        return `${record?.issueNumber ?? ""} (${
          record?.customRefNumber ?? ""
        })`;
      },
    });

    columns.push({
      title: "Quantity",
      dataIndex: "tiepQuantityPerMaterial",
      key: "tiepQuantityPerMaterial",
      align: "right",
      width: "20%",
    });

    if (order?.orderStage == StockReceiptOrderStage.UPDATE) {
      columns.push({
        title: "Status",
        dataIndex: "mode",
        key: "mode",
        align: "center",
        width: "7%",

        render: (text) => {
          let color = "";
          if (text === "AVAILABLE") {
            color = "#87d068";
          }
          if (text === "REQUESTED") {
            color = "#2db7f5";
          }
          if (text === "ISSUED") {
            color = "#108ee9";
          }
          if (text === "DELIVERED") {
            color = "#f50";
          }
          if (text === "LOADED") {
            color = "#87d068";
          }
          if (text === "READY") {
            color = "#87d068";
          }
          return <Tag color={color}>{text}</Tag>;
        },
      });

      columns.push({
        title: "",
        key: "action",
        width: "6%",
        render: (text, record) => {
          return (
            <span>
              {["AVAILABLE", "REQUESTED", "READY", "UPDATE"].includes(
                record.mode
              ) && (
                <Button
                  icon={<EditOutlined />}
                  title="Edit"
                  type="link"
                  style={{ marginRight: 10 }}
                  onClick={() => handleStockItemEdit(record.id)}
                ></Button>
              )}
              {["AVAILABLE", "REQUESTED", "READY", "UPDATE"].includes(
                record.mode
              ) && (
                <Popconfirm
                  title="Are you sure to delete this item?"
                  onConfirm={() => handleStockItemDelete(record.id)}
                  placement="left"
                >
                  <CloseOutlined />
                </Popconfirm>
              )}
            </span>
          );
        },
      });
    } else {
      columns.push({
        title: "Status",
        dataIndex: "mode",
        key: "mode",
        align: "center",
        width: "7%",
        render: (text) => {
          let color = "";
          if (text === "AVAILABLE") {
            color = "#87d068";
          }
          if (text === "REQUESTED") {
            color = "#2db7f5";
          }
          if (text === "ISSUED") {
            color = "#108ee9";
          }
          if (text === "DELIVERED") {
            color = "#f50";
          }
          if (text === "LOADED") {
            color = "#87d068";
          }
          if (text === "READY") {
            color = "#87d068";
          }
          return <Tag color={color}>{text}</Tag>;
        },
      });
    }

    return columns;
  };

  const grnLineRowSelection = {
    selectedRowKeys: selectedGrnLineKeys,
    onChange: (selectedGrnLineKeys) => {
      handleTabChange(selectedGrnLineKeys[0]);
    },
  };

  const getLineMaterialSuggestions = (id, pageNumber, pageSize) => {
    setLoadingLineItems(true);
    let paginationParams = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    stockReceiptService
      .getSuggestionNew(id, paginationParams)
      .then((result) => {
        setLineItemMap(lineItemMap.set(id, result.content));
        setTotalRecords(result.pagination.totalRecords);
        setPageNumber(result.pagination.pageNumber);
        setPageSize(result.pagination.pageSize);
        setLoadingLineItems(false);
      })
      .catch(() => {
        setLoadingLineItems(false);
      });
  };

  const handleTabChange = (activeKey) => {
    setActiveTabKey(activeKey?.toString());
    setSelectedGrnLineKeys([activeKey?.toString()]);
    if (!lineItemMap.get(activeKey)) {
      setLoadingLineItems(true);

      getLineMaterialSuggestions(activeKey, pageNumber, pageSize);
    }
  };

  const handlePaginateChange = (page, pagesize) => {
    setLoadingLineItems(true);
    getLineMaterialSuggestions(activeTabKey, page, pagesize);
  };

  const getTabContent = (grnLines) => {
    let tabPanes = [];

    grnLines.forEach((line, index) => {
      tabPanes.push(
        <Tabs.TabPane
          tab={`${line.stockTypeCode ?? "Items"} (${
            line.tiepPackageQuantity ?? 0
          })`}
          key={line.id}
        >
          <Spin tip="Loading..." spinning={loadingLineItems}>
            {lineItemMap.get(line.id) && (
              <Table
                bordered
                size="small"
                rowKey="id"
                columns={getStockItemColumns()}
                dataSource={lineItemMap.get(line.id)}
                expandable={{
                  expandedStockItemRender,
                  defaultExpandAllRows: true,
                }}
                pagination={{
                  current: pageNumber,
                  pageSize: pageSize,
                  total: totalRecords,
                  showTotal: (total) => `Total ${total} items`,
                  pageSizeOptions: [10, 20, 50, 100, 200],
                  showSizeChanger: true,
                  onChange: (page, pageSize) =>
                    handlePaginateChange(page, pageSize),
                }}
                summary={(pageData) => {
                  let totalQuantity = 0;
                  let totalItems = 0;

                  pageData.forEach(({ quantity, mode }) => {
                    if (mode === "AVAILABLE") {
                      totalQuantity += quantity ? quantity : 1;
                      totalItems += 1;
                    }
                  });

                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={4}>
                          <Text strong>Total Quantity</Text>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell></Table.Summary.Cell>

                        <Table.Summary.Cell align="right">
                          <Text strong style={{ paddingLeft: 12 }}>
                            {totalQuantity}
                          </Text>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell
                          align="right"
                          colSpan={
                            order?.orderStage == StockReceiptOrderStage.UPDATE
                              ? 2
                              : 1
                          }
                        ></Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            )}
          </Spin>
        </Tabs.TabPane>
      );
    });

    return tabPanes;
  };

  const getColumnsTaxTable = () => {
    const columns = [
      {
        title: "Tax Code",
        dataIndex: "code",
        key: "Code",
        width: "10%",
        align: "center",
      },
      {
        title: "Tax Name",
        dataIndex: "name",
        key: "Name",
        align: "center",
        width: "15%",
      },
      {
        title: "Tax Amount",
        dataIndex: "totalTaxAmount",
        key: "Amount",
        width: "15%",
        align: "center",
        render: (text, record) => CurrencyFormatter(text ?? 0),
      },
    ];

    return columns;
  };

  const expandedStockItemRender = (value) => {
    const getInnerStockColumns = () => {
      let columns = [];

      columns.push({
        title: "Barcode",
        dataIndex: "barcode",
        key: "barcode",
      });
      columns.push({
        title: "Job No.",
        dataIndex: "jobNumber",
        key: "jobNumber",
      });
      columns.push({
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
      });

      return columns;
    };

    return (
      <Table
        rowKey="id"
        columns={getInnerStockColumns()}
        dataSource={value.children}
        pagination={false}
      />
    );
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Stock Receipts Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`.replace(":id", id)}>
                {order.receiptNumber} ::{" "}
                <Tag
                  color={`${
                    order.orderStage === "OPEN"
                      ? "#2db7f5"
                      : order.orderStage === "IN_PROGRESS"
                      ? "#108ee9"
                      : "#87d068"
                  }`}
                >
                  {order.orderStage}
                </Tag>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Stepper status={order?.orderStage ?? "OPEN"} />
          <TabMenu menu="summary" id={id} />
          <Spin tip="Loading..." spinning={loading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item name={["customerName"]} label="Supplier">
                    <Input readonly />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["storeName"]}
                    label="Store"
                    rules={[{ required: true }]}
                  >
                    <Input readonly />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="receivedDate"
                    label="Receipt date"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="customRefNumber"
                    label="Customs Ref: #"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>

                {/* <Col span={6}>
                  <Form.Item
                    name="orderDate"
                    label="Order Date"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col> */}
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["customerAddress"]}
                    label="Deliver From"
                    rules={[{ required: true }]}
                  >
                    <Input></Input>
                    {/* <TextArea
                      readOnly
                      rows={5}
                      style={{
                        resize: "none",
                      }}
                    /> */}
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["storeAddress"]}
                    label="Delivery To"
                    rules={[{ required: true }]}
                  >
                    <Input></Input>
                    {/* <Text
                      readOnly
                      //rows={5}
                      style={{
                        resize: "none",
                      }}
                    /> */}
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="receiptNumber"
                    label="Receipt No"
                    rules={[{ required: true }]}
                  >
                    <Input readonly />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name="receiptType" label="Receipt Type">
                    <Input
                      readOnly
                      disabled
                      style={{
                        fontSize: "1.3rem",
                        border: "0px",
                        fontWeight: "bold",
                      }}
                      variant="borderless"
                    />
                  </Form.Item>
                </Col>
              </Row>

              {order && (
                <Row
                  gutter={24}
                  // style={{
                  //   backgroundColor: "#f2f2f2",
                  //   padding: "10px",
                  //   marginBottom: "10px",
                  // }}
                >
                  <Col span={8}>
                    <Table
                      size="small"
                      pagination={false}
                      bordered={false}
                      dataSource={order?.stockReceiptTaxViews || []}
                      columns={getColumnsTaxTable()}
                      rowKey={(record) => record.code || Math.random()}
                    />
                  </Col>

                  <Col span={8}></Col>
                  <Col span={8}></Col>
                </Row>
              )}
              {/* {order?.stockReceiptTaxViews?.map((item) => (
                <Row gutter={24}>
                  <Col span={6}></Col>
                  <Col span={6}></Col>
                  <Col span={6}></Col>
                  <Col span={6}>
                    {item?.code && (
                      <Form.Item
                        name={item.code}
                        label={item.name}
                        initialValue={item.totalTaxAmount}
                      >
                        <Input readonly disabled />
                      </Form.Item>
                    )}
                  </Col>
                </Row>
              ))} */}

              <Row gutter={24} style={{ marginTop: 20 }}>
                <Col span={6}>
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => (
                      <Form.Item label="Total VAT">
                        <Statistic
                          value={getFieldValue("totalVatAmount") ?? 0}
                          precision={2}
                          prefix="LKR"
                        />
                      </Form.Item>
                    )}
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name="totalLiabilityAmount" label="Total Gurantee">
                    <Statistic precision={2} prefix="LKR" />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name="totalTaxAmount" label="Total Amount">
                    <Statistic precision={2} prefix="LKR" />
                  </Form.Item>
                </Col>

                <Col span={6}></Col>
              </Row>
              {order?.receiptLines?.length > 0 && (
                <>
                  <Row gutter={24}>
                    <Table
                      bordered
                      pagination={false}
                      columns={getLineColumns()}
                      rowKey="id"
                      dataSource={order.receiptLines}
                      //expandable={{ expandedRowRender, defaultExpandAllRows: true }}
                      rowSelection={{
                        type: "radio",
                        ...grnLineRowSelection,
                      }}
                      rowClassName={(record) =>
                        record.quantity === record.receivedQuantity
                          ? "ant-tag-green"
                          : record.receivedQuantity > 0
                          ? "ant-tag-amber"
                          : ""
                      }
                      size="small"
                      scroll={{ x: 1800 }}
                      // summary={(pageData) => {
                      //   let totalPackageQuantity = 0;
                      //   let totalQuantity = 0;
                      //   let totalVat = 0;
                      //   let totalCid = 0;
                      //   let totalEid = 0;
                      //   let totalPal = 0;
                      //   let totalSsl = 0;
                      //   let totalDuty = 0;
                      //   let totalAmount = 0;

                      //   pageData.forEach(
                      //     ({
                      //       receivedPackages,
                      //       receivedInnerItems,
                      //       vat,
                      //       cid,
                      //       eid,
                      //       ssl,
                      //       pal,
                      //     }) => {
                      //       totalPackageQuantity += receivedPackages;
                      //       totalQuantity += receivedInnerItems;
                      //       totalVat += vat;
                      //       totalCid += cid;
                      //       totalEid += eid;
                      //       totalPal += pal;
                      //       totalSsl += ssl;
                      //     }
                      //   );

                      //   totalDuty = totalCid + totalEid + totalPal + totalSsl;
                      //   totalAmount = totalDuty + totalVat;

                      //   form.setFieldsValue({
                      //     vat: totalVat,
                      //     cid: totalCid,
                      //     eid: totalEid,
                      //     pal: totalPal,
                      //     ssl: totalSsl,
                      //     totalDuty: totalDuty,
                      //     totalAmount: totalAmount,
                      //   });

                      //   return (
                      //     <>
                      //       <Table.Summary.Row>
                      //         <Table.Summary.Cell colSpan={5}>
                      //           <Text strong>Total</Text>
                      //         </Table.Summary.Cell>
                      //         <Table.Summary.Cell align="right"></Table.Summary.Cell>
                      //         <Table.Summary.Cell align="right"></Table.Summary.Cell>
                      //         <Table.Summary.Cell align="right">
                      //           <Text strong>
                      //             {" "}
                      //             {Number(totalPackageQuantity).toFixed(2)}
                      //           </Text>
                      //         </Table.Summary.Cell>
                      //         <Table.Summary.Cell align="right">
                      //           <Text strong>
                      //             {Number(totalQuantity).toFixed(2)}
                      //           </Text>
                      //         </Table.Summary.Cell>
                      //         <Table.Summary.Cell align="right">
                      //           <Text strong>
                      //             {CurrencyFormatter(totalVat)}
                      //           </Text>
                      //         </Table.Summary.Cell>
                      //         {/* <Table.Summary.Cell align="right">
                      //           {CurrencyFormatter(totalDuty)}
                      //         </Table.Summary.Cell>
                      //         <Table.Summary.Cell align="right">
                      //           <Text strong>
                      //             {CurrencyFormatter(totalCid)}
                      //           </Text>
                      //         </Table.Summary.Cell>

                      //         <Table.Summary.Cell align="right">
                      //           <Text strong>
                      //             {CurrencyFormatter(totalEid)}
                      //           </Text>
                      //         </Table.Summary.Cell>
                      //         <Table.Summary.Cell align="right">
                      //           <Text strong>
                      //             {CurrencyFormatter(totalPal)}
                      //           </Text>
                      //         </Table.Summary.Cell>
                      //         <Table.Summary.Cell
                      //           align="right"
                      //           colSpan={"rest"}
                      //         >
                      //           <Text strong>
                      //             {CurrencyFormatter(totalSsl)}
                      //           </Text>
                      //         </Table.Summary.Cell> */}

                      //         {order?.orderStage == "UPDATE" ? (
                      //           <Table.Summary.Cell></Table.Summary.Cell>
                      //         ) : (
                      //           ""
                      //         )}
                      //       </Table.Summary.Row>
                      //     </>
                      //   );
                      // }}
                    />
                  </Row>

                  {order?.orderStage == StockReceiptOrderStage.COMPLETE ? (
                    <>
                      <Divider orientation="left">Stock Items</Divider>
                      <Tabs
                        onChange={handleTabChange}
                        activeKey={activeTabKey}
                        type="card"
                      >
                        {getTabContent(order.receiptLines)}
                      </Tabs>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </Form>

            <AddMaterialDrawer
              onDrawerClose={onCloseNewLineDrawer}
              isloading={loadingNewLine}
              finishSubmit={handleDrawerOnLineEditSubmit}
              isDrawerOpen={newLineDrawerVisible}
              title={"Edit Material"}
              initialValues={selectedLine}
            />
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default TiepSummary;
